import React, { useEffect } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useProjectsQuery } from '../api/use-projects-query'
import { useJiraIntegrationPage } from './jira-integration-page.provider'
import { Project } from '../api/shared'
import { SingleSelectComboboxObject } from '../../../../legacy-design-system/combobox'
import { transformFormDataToBugtrackerRequest } from '../../bugtrackers/api/build-api-payload-bugtracker-credentials'
import { JiraIntegrationForm } from './jira-form-schema'
import { JiraFormFieldTypes } from './jira-form-field-types'

export const determineInitialProjectValue = (
  projects: Project[],
  value: Project | string
) => {
  return typeof value === 'object'
    ? value
    : projects?.find((project) => project.id === value?.toString())
}

export const ProjectNameField = () => {
  const { formatMessage } = useIntl()

  const {
    state: { organizationUuid }
  } = useJiraIntegrationPage()
  const { getValues, setValue } = useFormContext<JiraIntegrationForm>()

  const { projects } = useProjectsQuery({
    organizationUuid,
    bugtrackerRequest: transformFormDataToBugtrackerRequest(getValues)
  })

  const {
    field: { onChange, value }
  } = useController({ name: JiraFormFieldTypes.PROJECT })

  useEffect(() => {
    if (projects) {
      onChange(determineInitialProjectValue(projects, value))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projects])

  const handleChange = (project: Project) => {
    if (project) {
      setValue('integration', false)
      onChange(project)
    }
  }

  return (
    <SingleSelectComboboxObject<Project>
      label={formatMessage({
        id: 'title_integrationsSettings_projectName'
      })}
      items={[{ items: projects ? projects : [] }]}
      value={
        typeof value === 'object'
          ? value
          : projects?.find((project) => project.id === value?.toString())
      }
      onChange={handleChange}
      itemToString={(item) => item.name}
      itemToID={(item) => item.name}
    />
  )
}
